export const InboxesToolBarName = 'inboxesToolBarComponent';
